export const VERSION = '26/06/2025 [12:54]';